exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-salida-detalle/documento-salida-detalle.component.css
// module id = ../../../../../src/app/components/documento-salida-detalle/documento-salida-detalle.component.css
// module chunks = main